import $i18n from 'panda-i18n';
import locales from './index';
$i18n.initPackage({
    locales: locales,
    name: 'cn-domain-form-item',
});
